import React, { useRef } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './VideoList.scss';
import { link } from '../../helpers/link';
import sendEvent from '../../helpers/tracking';
import { getString } from '../../helpers/styles';
import { srcSet, useDimensions } from '../../helpers/image';

export default function VideoList(props) {
  const { view, list, title } = props;

  const sidebarView = view === 'sidebar';
  const gridView = view === 'withoutSidebar';

  const mainList = gridView ? list : list.slice(0, 2);
  const sidebarList = sidebarView ? list : list.slice(2);

  return (
    <section>
      <div
        className={getString([
          {
            value: 'videoList_desktop',
            condition: true
          },
          {
            value: 'videoList_grid_view',
            condition: gridView
          },
          {
            value: 'videoList_sidebar_view',
            condition: sidebarView
          }
        ])}
      >
        {!sidebarView && (
          <div className="videoList_grid">
            <h2>{title}</h2>

            <ul>
              {mainList.map((item, idx) => (
                <VideoItem
                  key={idx}
                  {...props}
                  item={item}
                  eventTrackingCodes={['home', 'video-center']}
                />
              ))}
            </ul>
          </div>
        )}

        {!gridView && (
          <div className="videoList_sidebar">
            {sidebarView && <h2>{title}</h2>}

            <ul>
              {sidebarList.map((item, idx) => (
                <VideoItem
                  key={idx}
                  {...props}
                  item={item}
                  eventTrackingCodes={['home', 'video-right']}
                />
              ))}
            </ul>
          </div>
        )}
      </div>

      {!sidebarView && !gridView && (
        <div className="videoList_mobile">
          <h2>{title}</h2>

          {list[0] && (
            <VideoItem
              {...props}
              item={list[0]}
              eventTrackingCodes={['home', 'video-center']}
            />
          )}

          <ul className="videoList_mobile_slider">
            {list.slice(1).map((item, idx) => (
              <VideoItem
                key={idx}
                {...props}
                item={item}
                eventTrackingCodes={['home', 'video-center']}
              />
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}

function VideoItem(props) {
  const { item, eventTrackingCodes, isHomePage } = props;

  const date = new Date(item.publishedAt);

  const displayedDate = date.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });

  const videoRef = useRef();
  const authorRef = useRef();

  const videoDimensions = useDimensions(videoRef);
  const authorDimensions = useDimensions(authorRef);

  return (
    <li onClick={() => isHomePage && sendEvent(...eventTrackingCodes)}>
      {link(
        <div className="videoList_item">
          <div className="videoList_item_wrap">
            <div ref={videoRef} className="videoList_item_image">
              {videoDimensions && (
                <LazyLoadImage
                  alt="video-preview"
                  srcSet={srcSet(item.imageUrl, videoDimensions)}
                />
              )}
            </div>

            <p className="videoList_item_category">{item.parent.title}</p>

            <button className="videoList_item_button">
              <span />
            </button>
          </div>

          <div>
            <div className="videoList_item_info">
              <p>{item.title}</p>

              <span>
                {item.publishedAt && `, geupload op ${displayedDate}`}
              </span>
            </div>

            <div className="videoList_item_author">
              <div ref={authorRef} className="videoList_item_author_image">
                {authorDimensions && (
                  <LazyLoadImage
                    alt="author-image"
                    srcSet={srcSet(item.channel.imageUrl, authorDimensions)}
                  />
                )}
              </div>

              <div className="videoList_item_author_info">
                <p>{item.channel.displayName}</p>

                <span>
                  {item.channel.numberOfFollowers} volgers,
                  {` ${item.channel.contentCount} videos`}
                </span>
              </div>
            </div>
          </div>
        </div>,
        `/${item.uri}`
      )}
    </li>
  );
}
